// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 776 ? "477d4af2" : chunkId) + "." + {"699":"a075719a5fe85510","776":"1e395318420da376"}[chunkId] + ".js";
};